import { useEffect, useState } from "react";

export const IMAGE_WIDTHS = [160, 320, 480, 640, 960, 1280, 1920, 2560];
const isManagedImage = (src) => typeof src === "string" && /\/api\/images\/[^/?]+\/\d+\/[a-f0-9]{64}(?:[?#]|$)/i.test(src);
export function imageVariantUrl(src, width, format) {
  if (!isManagedImage(src)) return src;
  const base = process.env.REACT_APP_BACKEND_URL || (typeof window === "undefined" ? "http://localhost" : window.location.origin);
  const url = new URL(src, base);
  url.searchParams.set("w", String(IMAGE_WIDTHS.find(size => size >= width) || 2560));
  url.searchParams.set("format", format);
  return url.toString();
}

/** Browser format negotiation and responsive sizing for signed marketplace image URLs. */
export default function ResponsiveImage({ src, alt = "", imageWidth = 960, sizes, onError, decoding = "async", ...props }) {
  const [failedFormats, setFailedFormats] = useState([]);
  useEffect(() => setFailedFormats([]), [src]);
  if (!isManagedImage(src)) return <img {...props} src={src} alt={alt} sizes={sizes} decoding={decoding} onError={onError} />;
  const widths = IMAGE_WIDTHS.filter(width => width <= Math.min(2560, imageWidth * 2));
  const srcSet = format => widths.map(width => `${imageVariantUrl(src, width, format)} ${width}w`).join(", ");
  const displaySizes = sizes || `(max-width: ${imageWidth}px) 100vw, ${imageWidth}px`;
  const handleError = event => {
    const format = new URL(event.currentTarget.currentSrc || event.currentTarget.src).searchParams.get("format");
    if ((format === "avif" || format === "webp") && !failedFormats.includes(format)) {
      setFailedFormats(current => [...current, format]);
      return;
    }
    onError?.(event);
  };
  return (
    <picture style={{ display: "contents" }}>
      {!failedFormats.includes("avif") && <source type="image/avif" srcSet={srcSet("avif")} sizes={displaySizes} />}
      {!failedFormats.includes("webp") && <source type="image/webp" srcSet={srcSet("webp")} sizes={displaySizes} />}
      <img {...props} src={imageVariantUrl(src, imageWidth, "jpeg")} srcSet={srcSet("jpeg")} sizes={displaySizes}
        alt={alt} decoding={decoding} onError={handleError} />
    </picture>
  );
}
